<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="640px">
    <v-card v-if="dialog">
      <v-card-title class="headline">
        <h1>Excluir usuário</h1>
        <v-btn class="close-modal" @click="close">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout pa-4 wrap>
          <!-- Conferencia visual do usuario selecionado -->
          <v-flex xs12 class="mb-3">
            <div class="user-check pa-3 br-4">
              <h3 class="ma-0 fw-600">{{ person.name }}</h3>
              <small class="d-block">CPF: {{ cpfFormatter(person.cpf) }}</small>
              <small class="d-block">E-mail: {{ person.email }}</small>
            </div>
          </v-flex>

          <!-- Aviso do que acontece -->
          <v-flex xs12 class="mb-3">
            <div class="delete-warning pa-3 br-4">
              <p class="fw-600 mb-2">
                <i class="fal fa-exclamation-triangle mr-1"></i>Esta ação é irreversível. Ao confirmar:
              </p>
              <ul class="pl-4 ma-0">
                <li>Os dados pessoais serão anonimizados na base (nome, CPF, e-mail, telefone, endereço).</li>
                <li>Assinaturas ativas em Asaas / Vindi / Pagar.me serão canceladas.</li>
                <li>O histórico de doações e recibos é preservado para fins fiscais, mas passará a aparecer como "Doador excluído" nos relatórios.</li>
              </ul>
            </div>
          </v-flex>

          <!-- Motivo (obrigatorio, min 20 chars) -->
          <v-flex xs12>
            <v-textarea
              v-model="reason"
              label="Motivo da exclusão"
              placeholder="Descreva o motivo da exclusão (mínimo 20 caracteres)"
              :counter="2000"
              maxlength="2000"
              rows="3"
              outline
            ></v-textarea>
            <small v-if="reason && reason.trim().length < minReasonLength" class="c-red d-block">
              Informe um motivo com ao menos {{ minReasonLength }} caracteres ({{ reason.trim().length }}/{{ minReasonLength }}).
            </small>
          </v-flex>

          <!-- Contato/origem do pedido (opcional) -->
          <v-flex xs12>
            <v-text-field
              v-model="requestedBy"
              label="Solicitado por (opcional)"
              placeholder="E-mail do titular, ticket, etc."
            ></v-text-field>
          </v-flex>

          <!-- Duplo confirm -->
          <v-flex xs12>
            <v-checkbox
              v-model="irreversibleChecked"
              label="Estou ciente que a ação é irreversível"
              color="error"
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>

        <v-card-actions class="pa-0">
          <div class="footer-modal-atividades">
            <v-btn flat round color="white" class="btn btn-default px-5" large @click="close">Cancelar</v-btn>
            <v-btn
              flat
              round
              color="white"
              class="btn btn-primary px-5"
              large
              :disabled="!canDelete"
              @click="confirmDelete"
            >Excluir</v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script type="plain/text">
import UserService from "@/scripts/services/user.service";
import FormatterHelper from "@/scripts/helpers/formatter.helper";

const MIN_REASON_LENGTH = 20;

export default {
  data() {
    return {
      dialog: false,
      userService: new UserService(),
      person: {},
      reason: "",
      requestedBy: "",
      irreversibleChecked: false,
      minReasonLength: MIN_REASON_LENGTH,
      submitting: false
    };
  },
  computed: {
    canDelete() {
      return (
        !this.submitting &&
        this.irreversibleChecked &&
        !!this.reason &&
        this.reason.trim().length >= this.minReasonLength
      );
    }
  },
  methods: {
    cpfFormatter(cpf) {
      return new FormatterHelper().formatCpf(cpf);
    },
    open(person) {
      this.person = person || {};
      this.reason = "";
      this.requestedBy = "";
      this.irreversibleChecked = false;
      this.submitting = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirmDelete() {
      if (!this.canDelete) return;
      this.submitting = true;

      this.userService
        .anonymizeUser(this.person.userId, this.reason.trim(), this.requestedBy)
        .then(
          function(result) {
            const message = result && result.alreadyAnonymized
              ? "Usuário já estava anonimizado."
              : `Usuário excluído com sucesso! Protocolo de exclusão #${result ? result.deletionLogId : ""}`;
            this.$store.commit("SET_SNACKBAR_SUCCESS_MESSAGE", message);
            this.$emit("refresh");
            this.close();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.submitting = false;
            const message = error && error.errorMessage
              ? error.errorMessage
              : "Não foi possível excluir o usuário. Tente novamente ou contate o administrador.";
            this.$store.commit("SET_SNACKBAR_MESSAGE", message);
          }.bind(this)
        );
    }
  }
};
</script>

<style lang="css" scoped>
.user-check {
  background: #f5f6fa;
  border: 1px solid #e0e2ec;
}
.delete-warning {
  background: #fff5f5;
  border: 1px solid #f2c2c2;
  color: #8a1f1f;
}
.delete-warning ul li {
  margin-bottom: 4px;
}
.c-red {
  color: #d0021b;
}
</style>
